<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Agent Collections",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Agent Collections",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Agent Collections",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "agent.name",
          sortable: true,
          label: "AGENT",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "mode.name",
          sortable: true,
          label: "MODE",
        },
        {
          key: "ref_no",
          sortable: true,
          label: "REF",
        },
        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingRole: [],
      modeError: "",
      dateError: "",
      amountError:"",
      agentError:"",

      // Value from user input for adding Role
      data: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
        amount: "",
        ref_no: "",
        reason: "",
        agent_id: "",
      },
      // edit Role
      editdata: {
        name: "",
        date: "",
        amount: "",
        id: "",
      },
      // delete Role
      deletedata: {
        name: "",
        amount: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("agentcollection", ["AgentCollections", "SaveStatus"]),
    ...mapGetters("agentstock", ["Agents"]),
    ...mapGetters("setting", ["PaymentOptions"]),

    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.AgentCollections ? this.AgentCollections.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AgentCollections ? this.AgentCollections.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchAgentCollections: "agentcollection/fetchAgentCollections",
      FetchPaymentOptions: "setting/fetchPaymentOptions",
      FetchAgents: "agentstock/fetchAgents",
      AddAgentCollection: "agentcollection/addAgentCollection",
      EditAgentCollection: "agentcollection/editAgentCollection",
      DeleteAgentCollection: "agentcollection/deleteAgentCollection",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addCollection(modalId) {
      this.modal_id = modalId;

      if (this.data.date == "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }

      if (this.data.amount == "") {
        this.amountError = "Amount field is required";
        return;
      } else {
        this.amountError = "";
      }

      if (this.data.mode == "") {
        this.modeError = "Mode field is required";
        return;
      } else {
        this.modeError = "";
      }

      if (this.data.agent_id == "") {
        this.agentError = "Agent field is required";
        return;
      } else {
        this.agentError = "";
      }

      this.AddAgentCollection(this.data);
    },

    resetAddCat() {
      this.data.amount = "";
      this.data.date = moment(new Date()).format("YYYY-MM-DD");
      this.data.mode = "";
      this.data.agent_id = "";
      this.data.ref_no = "";
      this.data.reason = "";
      this.amountError = "";
      this.dateError = "";
      this.agentError="";
      this.modeError = "";
      this.modal_id = "";
    },
  
    resetEditCat() {
      this.editdata.amount = "";
      this.editdata.date = "";
      this.editdata.id = "";
      this.modeError = "";
      this.dateError = "";
      this.agentError="";
      this.modal_id = "";
    },

    resetDeleteCat() {
      this.deletedata.name = "";
      this.deletedata.amount = "";
      this.deletedata.id = "";
      this.modeError = "";
      this.dateError = "";
      this.agentError="";
      this.modal_id = "";
    },

    resetError() {
      this.modeError = "";
      this.dateError="";
      this.agentError="";
      this.dateError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.agent.name;
      this.editdata.amount = data.item.amount;
      this.editdata.date = data.item.date;
      this.editdata.id = data.item.id;
    },
    editCategory(modalId) {
      this.modal_id= modalId;
      if (this.editdata.date == ''){
        this.dateError="Date field is required";
        return;
      }else{
        this.dateError = '';
      }
      if (this.editdata.amount == ''){
        this.amountError="Reason field is required";
        return;
      }else{
        this.amountError = '';
      }

      this.EditAgentCollection(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.agent.name;
      this.deletedata.amount = data.item.amount;
      this.deletedata.id = data.item.id;
    },
    deleteCategory(modalId) {
      this.modal_id = modalId;
      this.DeleteAgentCollection(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchAgentCollections();
    this.FetchPaymentOptions();
    this.FetchAgents();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-md-9">
                      <h4 class="card-title">All Agent Collections</h4>
                  </div>
                  <div  class="col-md-3" align="right">
                      <b-button v-b-modal.add-category-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
                  </div>
              </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AgentCollections?AgentCollections:[]"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                    <b-btn-group>
                        <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-category-modal
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-category-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >

                    </b-btn-group>
                  
                </template>
              </b-table>
            </div>
            <Loader v-if="!AgentCollections"/>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-category-modal" hide-footer @hidden="resetAddCat">
        <template #modal-title> Add Agent Collection </template>
        <div class="form-group mb-3">
            <label>Date</label>
            <div class="input-group">
            <input
                type="date"
                class="form-control"
                @input="resetError()"
                v-model="data.date"
                v-limit-future-date
            />
            </div>
            <div class="text-danger" v-if="dateError">
            <em>{{ dateError }}</em>
            </div>
        </div>
        <div class="form-group mb-2">
            <label>Amount</label>
            <div class="input-group">
            <input
                type="number"
                placeholder="Enter amount"
                class="form-control"
                v-model="data.amount"
                @input="resetError()"
            />
            </div>
            <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
            </div>
        </div>
        <div class="form-group mb-3">
              <label>Select Mode <span class="text-danger">*</span></label>
              <model-list-select
                  :list="PaymentOptions ? PaymentOptions : []"
                  v-model="data.mode"
                  option-value="id"
                  option-text="mode"
                  class="mb-3"
                  placeholder="Select Mode"
                  @input="resetError()"
              >
              </model-list-select>

              <div class="text-danger" v-if="modeError">
                <em>{{modeError }}</em>
              </div>
        </div>
        <div class="form-group mb-3">
            <label>Ref No</label>
            <div class="input-group">
            <input
                type="text"
                placeholder="Ref no"
                class="form-control"
                v-model="data.ref_no"
            />
            </div>
            
        </div>
        <div class="form-group mb-3">
              <label>Select Agent <span class="text-danger">*</span></label>
              <model-list-select
                  :list="Agents ? Agents : []"
                  v-model="data.agent_id"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Agent"
                  @input="resetError()"
              >
              </model-list-select>

              <div class="text-danger" v-if="agentError">
                <em>{{agentError }}</em>
              </div>
        </div>
        <div class="form-group mb-3">
            <label>Reason</label>
            <div class="input-group">
            <input
                type="text"
                placeholder="Reason"
                class="form-control"
                v-model="data.reason"
            />
            </div>
            
        </div>
        <div class="modal-footer">
            <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-category-modal')"
            >
            <i class="fa fa-times"></i> Close
            </button>
            <button
            type="button"
            class="btn btn-primary"
            @click="addCollection('add-category-modal')"
            >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
                v-if="SaveStatus"
                variant="light"
                small
                label="Spinning"
            ></b-spinner>
            </button>
        </div>
    </b-modal>
    <!-- modal ends -->

    <!-- edit modal starts -->
            <b-modal id="edit-category-modal" hide-footer @hidden="resetEditCat">
              <template #modal-title> Edit Agent Collection of {{ editdata.amount }} From {{ editdata.name }}</template>
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-limit-future-date
                    @input="resetError"
                    v-model="editdata.date"
                  />
                </div>
                <div class="text-danger" v-if="dateError">
                  <em>{{ dateError }}</em>
                </div>
              </div>
              <div class="form-group mb-2">
                <label>Amount</label>
                <div class="input-group">
                <input
                    type="number"
                    placeholder="Enter Balance"
                    class="form-control"
                    v-model="editdata.amount"
                    @input="resetError()"
                />
                </div>
                <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
                </div>
            </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-category-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editCategory('edit-category-modal')"
                >
                <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete category starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-category-modal"
              hide-footer
              @hidden="resetDeleteCat"
            >
              <template #modal-title> Deactivate Agent Collection  of {{ deletedata.amount }}  From  {{ deletedata.name }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to Deactivate this Agent Collection? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-category-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteCategory('delete-category-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style> 
